export enum TenantValidationErrors {
    "ClientCode" = '_Tenant_Code_Already_Exists_',
    "ClientName" = '_Tenant_Name_Already_Exists_',
    "SolutionId" = '_SolutionID_Already_Exists_',
    "DatabaseName" = '_Database_Already_Exists_',
    "RequestAccepted" = "_Request_Accepted_For_Processing_"
}